// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e77e1adf","453":"d499bac4","732":"e41dea08","977":"6f45468e"}[chunkId] + ".chunk.js";
};